
import './App.css';
import ApplicationForm from './component/ApplicationForm';

function App() {
  return (
    <div>
      <ApplicationForm/>
      
    </div>
  );
}

export default App;
